import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import { Eye, EyeOff } from "lucide-react";
import { LoginAPI } from "./api/LoginAPI";
import Swal from "sweetalert2";
import { SaveUserToken } from "../../firebase/SaveUserToken";

const Login = () => {
 const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [type, setType] = useState('');

  const handleCreateAccount = () => {
    navigate("/register");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!email ||!type) {
      setError("Please fill in all fields");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email");
      return;
    }

    setIsLoading(true);

    try {
      const payload = { email, password };
      const res = await LoginAPI(type, payload);
      const data = res?.res?.data?.data || ''
      if (res?.success) {
        Swal.fire({
          icon: "success",
          title: "Login Successful!",
          showConfirmButton: false,
          timer: 1500,
        });
        const userId = data?._id || '001';
        const userName = data?.fullName || "Unknown User";
        await SaveUserToken(userId, userName,type);
        // console.log(data);
        const payload = {
          partnerCode:data.partnerCode,
          type
        }
        localStorage.setItem('user',JSON.stringify(payload))
        navigate("/dashboard");
        // console.log('cahak')
      } else {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: res?.message || "Incorrect email or password",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error?.message || "Incorrect email or password",
      });
    } finally {
      setIsLoading(false); // ⭐ MOST IMPORTANT
    }
  };

  return (
    <div className="rp-login-container">
      {/* Left Section - Branding */}
      <div className="rp-login-left-section">
        <div className="rp-login-decorative-shape shape-1"></div>
        <div className="rp-login-decorative-shape shape-2"></div>

        <div className="rp-login-content">
          <div className="rp-login-logo-wrapper">
            <div className="rp-login-logo-glass-card">
              <img
                src="/wealth_compounders_logo.png"
                alt="Wealth Compounders"
                className="rp-login-logo-img"
              />
            </div>
          </div>

          <h1 className="rp-login-title">Welcome Back</h1>
          <p className="rp-login-subtitle">
            Sign in to access your account and continue
            <br />
            your journey with us.
          </p>
         <div className="rp-login-footer-text">
            <span>Don't have an account? </span>
            <button onClick={handleCreateAccount}>Create Account</button>
          </div>
        </div>
      </div>

      {/* Right Section - Form */}
      <div className="rp-login-right-section">
        <div className="rp-login-form-container">
          <div className="rp-mobile-logo-placeholder">
            <img src="/wealth-compounders.png" alt="Logo" />
          </div>

          <h2 className="rp-login-form-title">Sign In</h2>
          <p className="rp-login-form-subtitle">
            Enter your credentials to access your account.
          </p>

          <form onSubmit={handleLogin}>
           <div className="rp-login-form-group">
              <label className="rp-login-label">Partner Type</label>
              <div className="rp-login-input-wrapper">
                <div className="rp-login-phone-input-container">
                  <select value={type} onChange={(e)=>setType(e.target.value)} className="rp-login-phone-input">
                    <option value='' disabled>Select Type</option>
                    <option value='wcPartner'>WC Partner</option>
                    <option value='referralPartner'>Referral Partner</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="rp-login-form-group">
              <label className="rp-login-label">Email</label>
              <div className="rp-login-input-wrapper">
                <div className="rp-login-phone-input-container">
                  <input
                    type="text"
                    onChange={(e) => setEmail(e.target.value)}
                    className="rp-login-phone-input"
                    placeholder="Enter Email"
                    value={email}
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>
            </div>
            {type==='referralPartner' &&
             <div className="rp-login-form-group">
              <label className="rp-login-label">Password</label>
              <div className="rp-login-input-wrapper">
                <div className="rp-login-phone-input-container">
                  <input
                  type={showPassword ? "text" : "password"}
                  className="rp-login-phone-input"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value.toLowerCase())}
                  required
                  disabled={isLoading}
                />
                <span
                  className="rp-login-password-toggle"
                  style={{display:'flex',justifyContent:'center',alignItems:'center',marginRight:'10px'}}
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </span>
                </div>
              </div>
            </div>
            }
            {error && (
              <p className="rp-login-card-error">
                Please enter correct email
              </p>
            )}
            <button
              type="submit"
              className="rp-otp-submit-btn"
              disabled={isLoading}
            >
              Login
            </button>

            <p className="rp-login-terms">
              By signing in, you agree to our <a href="/terms">Terms</a> and{" "}
              <a href="/privacy">Privacy Policy</a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
